export interface ICandidateResponseSimilar {
  similarQuestionId: string;
  questionOptionTitle?: string;
  answer?: string;
  path?: string;
}

export class CandidateResponseSimilar {
  public similarQuestionId: string;
  public questionOptionTitle?: string;
  public answer?: string;
  public path?: string;

  constructor(data: ICandidateResponseSimilar) {
    this.similarQuestionId = data.similarQuestionId;
    this.questionOptionTitle = data.questionOptionTitle;
    this.answer = data.answer;
    this.path = data.path;
  }
}
